import React from 'react';
import CourseCodes from './CourseCodes';
import { Container, Alert } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const CourseCodesManager: React.FC = () => {
  const { currentUser } = useAuth();

  // التأكد من وجود مستخدم مسجل الدخول
  if (!currentUser) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">
          يجب تسجيل الدخول أولاً للوصول إلى هذه الصفحة
        </Alert>
      </Container>
    );
  }

  return <CourseCodes />;
};

export default CourseCodesManager;
